/**
history-map
*/


<template>
    <div class="history-map-container">
        <div class="history-map-title"><div>{{ title }}</div></div>
        <div class="history-map">map component - {{ title }}</div>
        <history-map-legend v-bind:selected-items="legendItems"/>
        <div v-if="subtext" class="history-content history-map-subtext">{{ subtext }}</div>
    </div>
</template>


<script>
import L from "leaflet";
import { mapboxPublicToken, osmAttributionText, MCZs, SACs, SPAs, NCMPAs } from "../../../js/map-layers";

import HistoryMapLegend from "./history-map-legend.vue";


export default {
    name: "history-map",
    components: {
        HistoryMapLegend
    },
    props: {
        map: {type: String, required: true},
        title: {type: String, required: true},
        subtext: {type: String, required: false}
    },
    data: function () {
        return {
            mapObject: undefined,
            legendItems: []
        }
    },
    methods: {
        triggerMapDraw: function (obs) {
            if (obs[0].isIntersecting && !this.mapObject) {
                this.drawMap();
            }
        },
        drawMap: function () {
            // annoyingly have to create this in here - when importing leaflet gets upset about reuse and drops background mapping on all but the first map on the page
            const MapBoxBackgroundMapping = L.tileLayer(
                "https://api.mapbox.com/styles/v1/mapbox/outdoors-v11/tiles/{z}/{x}/{y}?access_token=" + mapboxPublicToken,
                {attribution: osmAttributionText}
            );

            this.mapObject = L.map(this.$el.querySelector(".history-map"), {
                crs: L.CRS.EPSG900913,
                zoomControl: false,
                zoomSnap: 0.25,
                scrollWheelZoom: false,
                center: [52.9, -1.5],
                zoom: 7,
                layers: [MapBoxBackgroundMapping]
            });
            new L.Control.Zoom({position: "bottomright"}).addTo(this.mapObject);

            // Messy with the big switch statement :(
            switch (this.map) {
                case "1982":
                    L.tileLayer.wms(
                        mparc.wmsUrl, {
                            layers: "rc3:rc3_view_history_1982",
                            format: 'image/png', transparent: true, tiled: true,
                            rcvc: mparc.versionMetadata.spa_dataset_version
                    }).addTo(this.mapObject);

                    this.mapObject.fitBounds([
                        [49.7, -6.5],
                        [60.8, -0.7]
                    ])

                    this.legendItems = ["spas-active"]
                    break;

                case "2004 SACs":
                    L.tileLayer.wms(
                        mparc.wmsUrl, {
                            layers: "rc3:rc3_view_history_2004_2007",
                            format: 'image/png', transparent: true, tiled: true,
                            rcvc: mparc.versionMetadata.sac_dataset_version
                    }).addTo(this.mapObject);

                    this.mapObject.fitBounds([
                        [49.7, -6.5],
                        [60.8, -0.7]
                    ])

                    this.legendItems = ["sacs-active", "spas-faded"]
                    break;

                case "MCZs":
                    L.tileLayer.wms(
                        mparc.wmsUrl, {
                            layers: "rc3:rc3_view_history_mczs",
                            format: 'image/png', transparent: true, tiled: true,
                            rcvc: mparc.versionMetadata.mcz_dataset_version
                    }).addTo(this.mapObject);

                    this.mapObject.fitBounds([
                        [48, -8],
                        [56.5, 3.8]
                    ]);

                    this.legendItems = ["mczs-active", "sacs-faded", "spas-faded"]
                    break;

                case "2016 NCMPAs":
                    L.tileLayer.wms(
                        mparc.wmsUrl, {
                            layers: "rc3:rc3_view_history_ncmpas",
                            format: 'image/png', transparent: true, tiled: true,
                            rcvc: mparc.versionMetadata.ncmpa_dataset_version
                    }).addTo(this.mapObject);

                    this.mapObject.fitBounds([
                        [55, -9],
                        [64, 1]
                    ]);

                    this.legendItems = ["ncmpas-active", "mczs-faded", "sacs-active", "spas-faded"]
                    break;

                case "current":
                    MCZs.addTo(this.mapObject);
                    SACs.addTo(this.mapObject);
                    SPAs.addTo(this.mapObject);
                    NCMPAs.addTo(this.mapObject);

                    this.mapObject.fitBounds([
                        [49, -6.5],
                        [64, -0.7]
                    ]);

                    this.legendItems = ["mczs-active", "sacs-active", "spas-active", "ncmpas-active"]
                    break;
            }
        }
    },
    computed: {},
    watch: {},
    mounted: function () {
        // only draw map when getting near to it down the screen to save creating all at once.
        const observer = new IntersectionObserver(this.triggerMapDraw, {
            threshold: 0.1,
            rootMargin: "0px 0px 500px 0px"
        })
        observer.observe(this.$el)
    }
}
</script>


<style lang="scss">
    @import "../../../styles/variables.scss";

    .history-map-container {
        width: 100%;
        margin: 30px 0;
        position: relative;
    }

    .history-map {
        height: 600px;

        @media screen and (max-width: 848px) {
            height: 450px;
        }
    }

    .history-map-subtext {
        font-size: 80%;
        font-style: italic;
        margin-top: 5px;
    }

    .history-map-title {
        @media screen and (min-width: 849px) {
            max-width: 840px;
            margin: 0 auto 0 auto;
            position: relative;

            div {
                position: absolute;
                left: 0;
                top: 10px;
                z-index: 1000;
                text-shadow: white 0 0 4px;
                pointer-events: none;
            }
        }

        div {
            display: inline-block;

            font-weight: 550;

            @media screen and (max-width: 848px) {
                margin-bottom: 2px;
                padding: 0 8px;
            }
        }
    }
</style>